import React from 'react';

const columns = [
  {
    name: 'Vn_Name',
    title: 'Vendor',
    type: 'text'
  },
  {
    name: 'Username',
    title: 'Username',
    type: 'text'
  },
  {
    name: 'Email',
    title: 'Email',
    type: 'text',
    getCellValue: (row) => {
      const { Email } = row;
      return (
        <a href={`mailto:${Email}`}>
          {Email}
        </a>
      )
    }
  },
  {
    name: 'Confirmed',
    title: 'Confirmed',
    type: 'text',
    getCellValue: (row) => row.Confirmed == 1 ? 'Yes' : 'No'
  },
  {
    name: 'TimeSheetRowCount',
    title: 'Time Sheet Rows',
    type: 'number'
  },
]

export default columns;